<template>
  <div class="bg">
    <div class="flexbox content" v-if="isLogin">
      <!-- 已登录 -->
      <div class="flexbox left">
        <!-- <router-link to="/"><i class="el-icon-s-home"></i>玫德官网</router-link> -->
        <router-link to="/">
          <!-- <i class="el-icon-s-home"></i> -->
          <img
            src="../../assets/img/icon/home.svg"
            style="width: 10px; height: 10px"
            alt=""
          />

          首页</router-link
        >

        <!-- <router-link to="/"><i class="el-icon-s-home"></i>首页</router-link> -->
        <p>{{ userInfo.customerName }}</p>
        <!-- <p>{{userInfo.CORPID}}</p> -->
        <p style="cursor: pointer" @click="logout">退出</p>
      </div>
      <div class="flexbox right">
        <el-dropdown @command="goto">
          <span class="el-dropdown-link">
            我的玫德
            <img
              src="../../assets/img/icon/down.svg"
              style="width: 10px; height: 10px"
              alt=""
            />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="MyCollection"
                >我的收藏</el-dropdown-item
              >
              <el-dropdown-item command="Profile">我的业务</el-dropdown-item>
              <el-dropdown-item command="OrderPath"
                >历史订单</el-dropdown-item
              >
              <!-- <el-dropdown-item command="FinancialReport">财务查询</el-dropdown-item> -->
              <el-dropdown-item command="OverBooking">下单明细</el-dropdown-item>
              <el-dropdown-item command="DeliverGoods">发货单</el-dropdown-item>
              <el-dropdown-item command="InvoiceProgress">开票进度</el-dropdown-item>
              <el-dropdown-item command="DebtList">欠款查询</el-dropdown-item>
              <el-dropdown-item command="PaymentCollection">回款查询</el-dropdown-item>
              <el-dropdown-item command="AccountStatement">对账单查询</el-dropdown-item>
              <el-dropdown-item command="OrderProgress">接单进度</el-dropdown-item>
              <el-dropdown-item command="SalesProgress">销售进度</el-dropdown-item>
              <el-dropdown-item command="DiscountReached">折扣达成进度</el-dropdown-item>
              <el-dropdown-item command="DiscountProvide">折扣发放进度</el-dropdown-item>
              <el-dropdown-item command="xpjh"
                >我的新品机会</el-dropdown-item
              >
                 <el-dropdown-item command="changePwd"
                >修改密码</el-dropdown-item
              >
              <!-- <el-dropdown-item command="FinancialOverview">我的财务</el-dropdown-item>
                        <el-dropdown-item command="FinancialInquiry">财务查询</el-dropdown-item>
                        <el-dropdown-item command="a">我的足迹</el-dropdown-item> -->
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <p>|</p>
        <router-link :to="{ name: 'MyOrder' }" class="orderb" tag="div"
          >我的订单</router-link
        >
        <!-- <p>|</p> -->
        <!-- <el-dropdown @command="goto">
                    <span class="el-dropdown-link">
                      消息<span class="redw">45条</span><i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="a">待办提醒<span class="redw">45条</span></el-dropdown-item>
                        <el-dropdown-item command="a">服务消息<span class="redw">45条</span></el-dropdown-item>
                        <el-dropdown-item command="a">系统消息<span class="redw">45条</span></el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                </el-dropdown> -->
                <p>|</p>
        <el-dropdown @command="goto">
          <span class="el-dropdown-link">
            客户服务
            <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            <img
              src="../../assets/img/icon/down.svg"
              style="width: 10px; height: 10px"
              alt=""
            />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
                          <el-dropdown-item command="popfots">我要投诉</el-dropdown-item>
              <el-dropdown-item command="Zhishiku">知识库</el-dropdown-item>
     <el-dropdown-item command="popforzx">我要咨询</el-dropdown-item>
              <el-dropdown-item command="MyQuestion">我的问题</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="flexbox content" v-else>
      <!-- 未登录 -->
      <div class="flexbox left">
        <router-link to="/"><i class="el-icon-s-home"></i>玫德官网</router-link>
        <router-link to="/login">登录</router-link>
        <!-- <router-link to="/register">注册</router-link> -->
      </div>
      <div class="flexbox right">
        <router-link to="/login" class="orderb" tag="div"
          >我的玫德<i class="el-icon-arrow-down el-icon--right"></i
        ></router-link>
        <p>|</p>
        <router-link to="/login" class="orderb" tag="div">我的订单</router-link>
        <p>|</p>
        <!-- <router-link to="/login" class="orderb" tag="div">消息<i class="el-icon-arrow-down el-icon--right"></i></router-link>
                <p>|</p> -->
        <router-link to="/login" class="orderb" tag="div"
          >客户服务<i class="el-icon-arrow-down el-icon--right"></i
        ></router-link>
      </div>
    </div>
    <el-dialog
      :title="formQTypeText"
      v-model="formQPop"
      width="650px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <CustomerService
        :formQType="formQType"
        :formQ="formQ"
        @formQHide="formQHide"
        :groupId="picgid"
      ></CustomerService>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import CustomerService from "@/components/customerservice/CustomerService";
import { ElMessage } from "element-plus";

export default {
  name: "HeaderTop",
  components: {
    CustomerService,
  },
  setup() {
    let router = useRouter();
    let { proxy } = getCurrentInstance();
    let pageData = reactive({
      userInfo: {},
    });
    let isLogin = ref(false);
    // 退出
    let logout = () => {
      proxy
        .$confirm("确认要退出登录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let data = {
            postType: "loginOut",
          };
          proxy.$axios
            .postReq("/meide/REST/LoginOut", data)
            .then((res) => {
              if (res.success == "true") {
                ElMessage.success({
                  message: res.Info,
                  type: "success",
                });
                localStorage.removeItem("userId");
                localStorage.removeItem("userInfo");
                setTimeout(() => {
                  router.push({
                    name: "Login",
                  });
                }, 500);
              } else {
                proxy.$alert(res.ErrorText, "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              }
            })
            .catch((error) => {
              // proxy.$alert(error, '提示', {
              //     confirmButtonText: '确定',
              //     callback: action => {}
              // });
            });
        })
        .catch(() => {});
    };
    // 未登录
    let handleCommand = () => {
      router.push("/login");
    };
    // ZX 咨询 TS 投诉
    let formQ = ref({
      code: "",
      customer: "",
      phone: "",
      linkman: "",
      salesman: "",
      theme: "",
      desc: "",
      annex: "",
      item: [],
    });
    let formQType = ref("ZX");
    let formQTypeText = ref("咨询");
    let formQPop = ref(false);
    let picgid = ref("");
    let goto = (command) => {
   
        if(command=='xpjh'){
          router.push({
                name: 'GoodsList',
                query: { type: 'querymore', keywords: 'xptj' },
              })
        }
           if(command=='changePwd'){
          router.push({
                name: 'ChangePwd',
           
              })
              return
        }
      if (localStorage.getItem("userInfo")) {
        if (command == "popforzx") {
          formQType.value = "ZX";
          formQTypeText.value = "咨询";
          getProblemCode("ZX");
          formQPop.value = true;
          for (let key in formQ.value) {
            formQ.value[key] = "";
          }
          formQ.value.item = [];
        } else if (command == "popfots") {
          formQType.value = "TS";
          formQTypeText.value = "投诉";
          getProblemCode("TS");
          formQPop.value = true;
          for (let key in formQ.value) {
            formQ.value[key] = "";
          }
          formQ.value.item = [];
        } else {
          router.push({ name: command });
        }
      } else {
        router.push("/login");
      }
    };
    // 获取问题编码
    let getProblemCode = (type) => {
      let data = {
        postType: "loadSub",
        type: type, // 咨询：ZX 投诉:TS
        source: "customer",
      };
      proxy.$axios
        .postReq("/meide/REST/ProblemCloseSub", data)
        .then((res) => {
          if (res.success == "true") {
            formQ.value.code = res.problemCode;
            formQ.value.customer = res.customerShortName;
            formQ.value.phone = pageData.userInfo.MOBILE;
          } else {
            proxy.$alert(res.ErrorText, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch((error) => {
          // proxy.$alert(error, '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {}
          // });
        });
    };
    let formQHide = (show) => {
      formQPop.value = show;
    };
    let getUserInfo = () => {
      // 获取用户信息
      let datauser = {
        postType: "queryInfo",
        customerId: pageData.userInfo.USERID,
      };
      // proxy.$axios.postReq('/meide/REST/QueryUserIdInfo', datauser)
      // .then(res => {
      //     if(res.success == 'true') {
      //         // let storeData = JSON.stringify(res.data)
      //         // localStorage.setItem('userInfo', storeData)
      //         // router.push('/')
      //         console.log(res.data)
      //     }else {
      //         proxy.$alert(res.ErrorText, '提示', {
      //             confirmButtonText: '确定',
      //             callback: action => {}
      //         });

      //     }
      // }).catch(error => {
      //     proxy.$alert(error, '提示', {
      //         confirmButtonText: '确定',
      //         callback: action => {}
      //     });
      // })
    };
    onBeforeMount(() => {
      if (localStorage.getItem("userInfo")) {
        pageData.userInfo = JSON.parse(localStorage.getItem("userInfo"));

        isLogin.value = true;
      } else {
        isLogin.value = false;
      }
      getUserInfo();
    });
    return {
      ...toRefs(pageData),
      isLogin,
      handleCommand,
      goto,
      formQPop,
      formQType,
      formQTypeText,
      formQ,
      formQHide,
      getProblemCode,
      logout,
      getUserInfo,
      picgid,
    };
  },
};
</script>


<style>
.el-dialog__title{
  font-weight: 700;
}
</style>
<style scoped lang="scss">

.bg {
  width: 100%;
  background: rgba(226, 226, 226, 1);
}
.content {
  width: 1200px;
  margin: auto;
  justify-content: space-between;
  height: 30px;
  .left {
    p {
      font-size: 12px;
      color: #666;
      margin-right: 20px;
    }
    a {
      font-size: 12px;
      color: #666;
      margin-right: 20px;
      i {
        margin-right: 5px;
      }
    }
  }
  .right {
    p {
      color: #999;
      margin: 0 10px;
    }
    .orderb {
      font-size: 12px;
      color: #666;
      /* &:hover {
                    color: rgb(244,36,52);
                } */
    }
    ::v-deep(.el-dropdown) {
      span {
        font-size: 12px;
        color: #666;
      }
      span.redw {
        color: rgb(244, 36, 52);
        margin-left: 3px;
      }
    }
  }
}
::v-deep(.el-dropdown-menu__item) {
  font-size: 12px;
  color: #666;
  &:hover {
    background: none;
    color: rgb(244, 36, 52);
  }
  .redw {
    color: rgb(244, 36, 52);
    margin-left: 3px;
    font-size: 12px;
  }
}
.popbox {
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .popcon {
    width: 580px;
    background: #fff;
    h3 {
      background: rgba(242, 242, 242, 1);
      font-weight: bold;
      padding: 15px 20px;
      font-size: 16px;
      color: #666;
      margin-bottom: 15px;
      span {
        float: right;
        font-weight: bolder;
        font-size: 20px;
        margin-top: -5px;
        cursor: pointer;
      }
    }
    ::v-deep(.el-form) {
      padding: 0 20px;
      .el-input--small .el-input__inner {
        width: 165px;
      }
      .longinput .el-input--small .el-input__inner,
      .longinput .el-textarea__inner {
        width: 400px;
      }
      .block {
        width: 100%;
        text-align: right;
      }
    }
  }
}
</style>